export const ROUNDED_CORNERS = '3px';
export const CIRCULAR = '50%';
/**
 * @deprecated don't use this
 */

export const DROPDOWN_ARROW_SIZE = '10px';